import "whatwg-fetch";
// TODO: move this to some config file

let endPoint = "http://localhost:8080";
if (window.location.hostname !== "localhost") {
  endPoint = "https://api.med-solutions.eu";
}

const apiRequest = (method, path, data, useAuth) => {
  const requestSettings = {
    method: method,
  };
  if (["post", "put"].indexOf(method) > -1) {
    requestSettings.body = JSON.stringify(data);
  }
  const url = path.startsWith("/") ? endPoint + path : path;
  return fetch(url, requestSettings).then((res) => res.json());
};
const get = (path, data = null, useAuth = true) => {
  return apiRequest("get", path, data, useAuth);
};
const post = (path, data = null, useAuth = false) => {
  return apiRequest("post", path, data, useAuth);
};
const put = (path, data = null, useAuth = true) => {
  return apiRequest("put", path, data, useAuth);
};
export { get, post, put };



// WEBPACK FOOTER //
// ./src/utils/apiHandler.js